import { CollapsibleList, SimpleListItem, } from "@rmwc/list";
import '@rmwc/list/styles';
import _ from "lodash";
import PropTypes from "prop-types";
import { useEffect, useState } from "react";
import { useGetServiceTypeLibelle } from "Achat/Components/Utils/achatHook";
import { selectIcon } from "Shared/Utils/Icon";
import "./DistributionList.css";
import { DistributionListItem } from "./DistributionListItem";

// #region FONCTION COMPOSANT
/**
 * Composant permettant d'afficher la liste pour achat sur une borne
 * @category Distribution
 * @param {DistributionList.propTypes} props Les propriétés du composant
 */
function DistributionList(props) {
  //#region INITIALISATION
  // Récupération des props
  const {
    categorie,
    handleRachat
  } = props;

  const [data, setData] = useState([]);
  
  // AYB 25.12.04 Traduction du nom de la catégorie
  const translatedName = useGetServiceTypeLibelle(parseInt(categorie.id)) || categorie.name;
  // #endregion

  // #region EVENTS
  const initializeData = () => {
    const cloneData = _.cloneDeep(categorie.detailAchats);
    const dataGroup = _.groupBy(cloneData, "idService");
    const keys = Object.keys(dataGroup);

    let newArray = [];

    keys.forEach(key => {
      const lastAchat = dataGroup[key][0];

      newArray.push(lastAchat);
    });

    setData(newArray);
  };
  // #endregion

  //#region HOOK D'EFFET
  //AYB 2025.11.14 Nettoyage du setTimeout pour éviter setState après démontage
  // useEffect(() => {
  //   setTimeout(() => {
  //     initializeData();
  //   }, 1500);
  //   // eslint-disable-next-line react-hooks/exhaustive-deps
  // }, [categorie]);

  useEffect(() => {
    let isMounted = true;
    const timerId = setTimeout(() => {
      if (isMounted) {
        initializeData();
      }
    }, 1500);

    return () => {
      isMounted = false;
      clearTimeout(timerId);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [categorie]);
  //#endregion

  //#region INTERFACE
  return (
    <CollapsibleList
      key={categorie.id}
      defaultOpen
      handle={
        <SimpleListItem
          className="DistributionList-HeaderList"
          graphic={selectIcon(categorie.id)}
          metaIcon="chevron_right"
          text={translatedName}
        />
      }
    >
      {data.map((item) => {
        return (
          <DistributionListItem
            key={item.idDetailAchat}
            detailAchat={item}
            handleRachat={handleRachat}
          />
        )
      })}
    </CollapsibleList>
  );
  // #endregion
};
// #endregion

// #region PROPRIETES
/**
 * Type des propriétés de {@link DistributionList}, hérite des propriétés de {@link DistributionListItem}
 * @typedef {Object} DistributionList.propTypes
 * @property {object} categorie La liste des catégories des items de la borne
 */
DistributionList.propTypes = {
  categorie: PropTypes.object.isRequired
};
// #endregion

export { DistributionList };

